import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { useToggleSlicesApiEnabledMutation } from "../queries.generated"
import {
  SiteDetailsSlicesApiEnabledFieldsFragment,
  SiteDetailsSlicesApiEnabledFieldsFragmentDoc,
} from "../fragments.generated"

export function useToggleSlicesAPI(siteId: string) {
  const [
    toggleSlicesAPIEnabledMutation,
    { loading },
  ] = useToggleSlicesApiEnabledMutation()
  const [setError, errorAlert] = useTriggerErrorAlert()

  const toggleIncrementalDeploysProduction = () => {
    setError(null)
    return toggleSlicesAPIEnabledMutation({
      variables: {
        siteId,
      },
      update: (proxy, { data }) => {
        if (!data?.toggleSlicesAPIEnabled?.success) {
          return
        }

        const fragmentInfo = {
          id: `Site:${siteId}`,
          fragment: SiteDetailsSlicesApiEnabledFieldsFragmentDoc,
        }

        const site = proxy.readFragment<
          SiteDetailsSlicesApiEnabledFieldsFragment
        >(fragmentInfo)

        if (!site) {
          return
        }

        site.slicesAPIEnabled = !site.slicesAPIEnabled

        proxy.writeFragment<SiteDetailsSlicesApiEnabledFieldsFragment>({
          ...fragmentInfo,
          data: site,
        })
      },
      optimisticResponse: {
        toggleSlicesAPIEnabled: {
          success: true,
          message: null,
          __typename: `MutationResult`,
        },
      },
    }).catch(err => setError(err))
  }

  return [toggleIncrementalDeploysProduction, { loading, errorAlert }] as const
}
